/**
 * User actions script file
 *
 * @package    Actions
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights
 *     reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import UserApi from 'Api/user';
import { keepAlive } from 'Actions/auth';
import { push } from 'react-router-redux';

export const USER_DATA_REQUEST = 'USER_DATA_REQUEST';
export const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
export const USER_DATA_ERROR = 'USER_DATA_ERROR';

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';

export const MY_PROFILE_UPDATE_REQUEST = 'MY_PROFILE_UPDATE_REQUEST';
export const MY_PROFILE_UPDATE_SUCCESS = 'MY_PROFILE_UPDATE_SUCCESS';
export const MY_PROFILE_UPDATE_ERROR = 'MY_PROFILE_UPDATE_ERROR';

export const USER_DATA_CLEAR = 'USER_DATA_CLEAR';

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_ERROR = 'USER_LIST_ERROR';
export const USER_LIST_UPDATE_FILTER = 'USER_LIST_UPDATE_FILTER';

export const USER_LIST_AUTOCOMPLETE_REQUEST = 'USER_LIST_AUTOCOMPLETE_REQUEST';
export const USER_LIST_AUTOCOMPLETE_SUCCESS = 'USER_LIST_AUTOCOMPLETE_SUCCESS';
export const USER_LIST_AUTOCOMPLETE_ERROR = 'USER_LIST_AUTOCOMPLETE_ERROR';

export const USER_LIST_ROLES_REQUEST = 'USER_LIST_ROLES_REQUEST';
export const USER_LIST_ROLES_SUCCESS = 'USER_LIST_ROLES_SUCCESS';
export const USER_LIST_ROLES_ERROR = 'USER_LIST_ROLES_ERROR';

export const JOURNALS_AUTOCOMPLETE_REQUEST = 'JOURNALS_AUTOCOMPLETE_REQUEST';
export const JOURNALS_AUTOCOMPLETE_SUCCESS = 'JOURNALS_AUTOCOMPLETE_SUCCESS';
export const JOURNALS_AUTOCOMPLETE_ERROR = 'JOURNALS_AUTOCOMPLETE_ERROR';

export const USER_AUTOCOMPLETE_CLEAR = 'USER_AUTOCOMPLETE_CLEAR';

/**
 * Load model data
 *
 * @param {number} id
 * @returns {*}
 */
export function loadUserData(id) {
    return {
        requestType: 'USER_DATA',
        request: UserApi.loadUserData(id),
    };
}

/**
 * Store user
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function storeUser(data) {
    return {
        requestType: 'USER_UPDATE',
        request: UserApi.storeUser(data),
        success: (response, dispatch) => {
            dispatch(push('/users'));

            return {
                payload: response.data,
            };
        },
    };
}

/**
 * Update user
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function updateUser(data) {
    const { id } = data;
    return {
        requestType: 'USER_UPDATE',
        request: UserApi.updateUser(id, data),
        success: (response, dispatch) => {
            dispatch(push('/users'));

            return {
                payload: response,
            };
        },
    };
}

/**
 * Update user
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function updateMyProfile(data) {
    const { id } = data;
    return {
        requestType: 'MY_PROFILE_UPDATE',
        request: UserApi.updateUser(id, data),
        success: (response, dispatch) => {
            dispatch(keepAlive());

            return {
                payload: response,
            };
        },
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function load(filter = {}) {
    return {
        requestType: 'USER_LIST',
        request: UserApi.find(filter),
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadAutocomplete(filter = {}) {
    return {
        requestType: 'USER_LIST_AUTOCOMPLETE',
        request: UserApi.find(filter),
    };
}

/**
 * Update filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateFilter(filter = {}) {
    return {
        type: USER_LIST_UPDATE_FILTER,
        payload: filter,
    };
}

/**
 * @returns {Object}
 */
export function loadRoles() {
    return {
        requestType: 'USER_LIST_ROLES',
        request: UserApi.findRoles(),
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadJournalsAutocomplete(filter = {}) {
    return {
        requestType: 'JOURNALS_AUTOCOMPLETE',
        request: UserApi.findJournals(filter),
    };
}

/**
 * Load model data
 *
 * @returns {*}
 */
export function clearUserData() {
    return {
        type: USER_DATA_CLEAR,
    };
}
/**
 * Clear autocomplete store
 *
 * @returns {{type: string}}
 */
export function clearAutocomplete() {
    return {
        type: USER_AUTOCOMPLETE_CLEAR,
    };
}



// WEBPACK FOOTER //
// ./src/actions/user.js